import { render, staticRenderFns } from "./ExternalFinishing.vue?vue&type=template&id=0ead053a&lang=pug&"
import script from "./ExternalFinishing.vue?vue&type=script&lang=js&"
export * from "./ExternalFinishing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports